export const TText        = ()  => import('./TText.vue')
export const Paragraph   = ()  => import('./Paragraph.vue')
export const OrderedList = ()  => import('./OrderedList.vue')
export const ListItem    = ()  => import('./ListItem.vue')
export const TImage       = ()  => import('./TImage.vue')
export const HardBreak   = ()  => import('./HardBreak.vue')
export const BulletList  = ()  => import('./BulletList.vue')


